"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletePage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var page_path_1 = require("../components/page_path");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var CompletePage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "#",
                        title: "Employment Details",
                    },
                    {
                        title: "Complete",
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex flex-col gap-4 items-center justify-center" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Data Succesfully Captured", textColor: "text-primary", bold: true, size: "3xlarge" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your Employment Data Was Saved Succesfully", textColor: "text-secondary" })),
                react_1.default.createElement("div", { className: "flex justify-center gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Home Page", backgroundColor: "bg-primary", size: "small", endIcon: pro_solid_svg_icons_1.faHouse, onClick: function () {
                            navigate("/");
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Shop Page", backgroundColor: "bg-secondary", size: "small", endIcon: pro_solid_svg_icons_1.faBasketShopping, onClick: function () {
                            navigate("/shop");
                        } }))))));
};
exports.CompletePage = CompletePage;
